import React from 'react';
import { Tooltip, Icon } from 'antd';

const LabelWithTooltip = ({ label, tooltipTitle }) => {
  return (
    <>
      {label}{' '}
      <Tooltip placement="topRight" title={tooltipTitle}>
        <Icon type="question-circle" />
      </Tooltip>
    </>
  );
};

export default LabelWithTooltip;
